// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewcontrolNodeId } from './BrewcontrolNode';
import { brewcontrolWorkspaceId } from './BrewcontrolWorkspace';
import { brewcontrolConfigKindEnum } from './BrewcontrolConfigKindEnum';
import { brewcontrolConfigVersionId } from './BrewcontrolConfigVersion';
import { brewcontrolEventId } from './BrewcontrolEvent';
import { z } from 'zod';
export const brewcontrolConfigAppliedId = (z.string());
export const brewcontrolConfigApplied = z.object({
    id: brewcontrolConfigAppliedId,
    node_id: brewcontrolNodeId,
    workspace_id: brewcontrolWorkspaceId.nullable(),
    kind: brewcontrolConfigKindEnum,
    version_id: brewcontrolConfigVersionId,
    event_id: brewcontrolEventId,
    applied_at: z.date(),
    superseded_at: z.date().nullable(),
});
export const brewcontrolConfigAppliedInitializer = z.object({
    id: brewcontrolConfigAppliedId.optional(),
    node_id: brewcontrolNodeId,
    workspace_id: brewcontrolWorkspaceId.optional().nullable(),
    kind: brewcontrolConfigKindEnum,
    version_id: brewcontrolConfigVersionId,
    event_id: brewcontrolEventId,
    applied_at: z.date(),
    superseded_at: z.date().optional().nullable(),
});
export const brewcontrolConfigAppliedMutator = z.object({
    id: brewcontrolConfigAppliedId.optional(),
    node_id: brewcontrolNodeId.optional(),
    workspace_id: brewcontrolWorkspaceId.optional().nullable(),
    kind: brewcontrolConfigKindEnum.optional(),
    version_id: brewcontrolConfigVersionId.optional(),
    event_id: brewcontrolEventId.optional(),
    applied_at: z.date().optional(),
    superseded_at: z.date().optional().nullable(),
});
//# sourceMappingURL=BrewcontrolConfigApplied.js.map